/**
 * CartDrawer styled components.
 */
import styled from 'styled-components'
import Icon from 'antd/lib/icon'
import { PrimaryCTA } from '../../theme/components'

export const CartDiv = styled.div`
  display: flex;
  flex-flow: column;
  position: fixed;
  background: white;
  height: 100vh;
  max-width: 420px;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 999;
  box-shadow: 4px 0 32px 0 rgba(0, 0, 0, 0.18);
  animation: slide-in-left 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  @keyframes slide-in-left {
    0% {
      transform: translateX(-450px);
    }
    100% {
      transform: translateX(0);
    }
  }
`

export const CartTitle = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: var(--spacing-24);
  background: var(--neutral-darker);
  color: var(--neutral-white);
  font: 600 16px/22px var(--font-barlow);
  letter-spacing: -0.1px;
`

export const CloseIcon = styled(Icon)`
  font-size: 22px;
  transition: all 0.25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const CartIconMini = styled.img`
  width: 22px;
  height: 22px;
  margin-right: 12px;
  vertical-align: top;
`

export const CartList = styled.div`
  display: flex;
  flex-flow: column;
  padding: var(--spacing-16) 26px 0 var(--spacing-16);
  margin-right: 6px;
  overflow-y: scroll;
  flex: 1;
  &.is-empty {
    padding: 0;
    margin-top: 0;
  }
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 8px;
    margin: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #6B6B6B;
  }
  &::-webkit-scrollbar-track {
    background: #EBEBEB;
    border-radius: 4px;
  }
`

export const EmptyCart = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  padding: 32px;
  text-align: center;
`

export const EmptyCartTitle = styled.div`
  margin: 0;
  font: 600 20px/26px var(--font-barlow-semi-condensed, 'Barlow Semi Condensed', sans-serif);
  letter-spacing: 0.6px;
  color: var(--neutral-darkest, #0a0a09);
`

export const EmptyCartMessage = styled.div`
  margin: 0;
  max-width: 356px;
  font: 400 14px/22px var(--font-inter, Inter, sans-serif);
  color: var(--neutral-secondary, #737370);
`

export const CartItemDiv = styled.div`
  display: flex;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #D4D5D8;
`

export const CartThumbnail = styled.img`
  max-width: 102px;
  width: 100%;
  object-fit: cover;
  height: 136px;
  padding: 6px;
  background: var(--lightened-cool);
`

export const CartInfo = styled.div`
  display: flex;
  flex-flow: column;
  position: relative;
  margin-left: 12px;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  padding-right: 36px;
  gap: 2px;
`

export const DesignName = styled.div`
  overflow: hidden;
  color: var(--neutral-darkest);
  text-overflow: ellipsis;
  font: 600 14px/24px var(--font-barlow);
`

export const DesignCode = styled.div`
  color: var(--neutral-body);
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
`

export const ProductName = styled.div`
  overflow: hidden;
  color: var(--neutral-body);
  text-overflow: ellipsis;
  font: 400 12px/20px var(--font-inter);
`

export const Field = styled.div`
  overflow: hidden;
  color: var(--neutral-muted);
  text-overflow: ellipsis;
  font: 400 10px/14px var(--font-barlow);
  letter-spacing: 0.2px;
  span {
    font-weight: 600;
  }
`

export const Quantity = styled.div`
  position: absolute;
  right: 0;
  top: calc(50% - 5px);
  color: var(--neutral-white);
  font: 400 12px/20px var(--font-inter);
  border-radius: 30px;
  background: #4A4A48;
  min-width: 24px;
  padding: 2px var(--spacing-4);
  text-align: center;
`

export const DeleteIcon = styled(Icon)`
  position: absolute;
  right: 0px;
  top: 4px;
  border-radius: 50px;
  color: var(--neutral-darkest);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const CartButtonOpen = styled(PrimaryCTA)`
  margin: var(--spacing-16) var(--spacing-24);
  width: auto;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CartDrawer/styledComponents.tsx